// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.sidenav-item[data-v-6ede82dd] {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 24px;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: all 0.2s;
  position: relative;
}
.sidenav-item[data-v-6ede82dd]:hover {
  color: white;
  background: rgba(255, 255, 255, 0.05);
}
.sidenav-item.active[data-v-6ede82dd] {
  color: white;
  background: rgba(255, 255, 255, 0.1);
}
.sidenav-item.active[data-v-6ede82dd]::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 0 3px 3px 0;
}
.sidenav-icon[data-v-6ede82dd] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}
.sidenav-text[data-v-6ede82dd] {
  font-size: 14px;
  font-weight: 500;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
